import React from "react";
import { Sparkles, Award, Briefcase, FileBadge2 } from "lucide-react";
import PresentazioneVideo from "./PresentazioneVideo";

const HIGHLIGHTS = [
  { icon: Briefcase, t: "Consulenza Professionale", d: "Supporto diretto a soci, cittadini e imprese" },
  { icon: Award, t: "Certificazione L. 4/2013", d: "Riconoscimento Agg. MIMIT" },
  { icon: FileBadge2, t: "Timbro & Carta Intestata", d: "Strumenti operativi per la libera professione" },
];

/**
 * Sezione video di presentazione ufficiale A.C.D.T. per la Home.
 * Usa il componente riutilizzabile PresentazioneVideo (click-to-play).
 */
export default function VideoPresentation() {
  return (
    <section
      id="video-presentazione"
      className="relative py-24 md:py-28 overflow-hidden"
      data-testid="home-video-presentazione"
    >
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-[#102a6b]/10 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-[#f59e0b]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-slate-200 text-[12px] font-semibold text-[#102a6b] shadow-sm">
            <Sparkles className="h-3.5 w-3.5 text-[#f59e0b]" />
            Scopri A.C.D.T. in meno di 2 minuti
          </div>
          <h2 className="mt-4 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
            La voce dell&apos;<span className="text-[#102a6b]">Associazione</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Il video ufficiale della nostra missione, del lavoro dei Consulenti Digitali
            e delle opportunità che offriamo a professionisti, imprese e cittadini.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8 reveal">
            <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_80px_-25px_rgba(16,42,107,0.45)]">
              <PresentazioneVideo rounded="rounded-3xl" />
            </div>
          </div>

          <aside className="lg:col-span-4 reveal space-y-3">
            {HIGHLIGHTS.map((h, i) => {
              const I = h.icon;
              return (
                <div
                  key={h.t}
                  className="rounded-2xl border border-slate-200 bg-white p-5 lift flex items-start gap-3"
                  style={{ transitionDelay: `${i * 70}ms` }}
                >
                  <div className="h-11 w-11 rounded-xl bg-[#102a6b] text-white flex items-center justify-center shrink-0">
                    <I className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-[15px] font-extrabold text-[#0a1f55] leading-tight">{h.t}</h3>
                    <p className="mt-1 text-[13px] text-slate-600 leading-relaxed">{h.d}</p>
                  </div>
                </div>
              );
            })}
            <div className="rounded-2xl bg-[#0a1f55] text-white p-5">
              <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#fbbf24]">
                Video ufficiale
              </div>
              <p className="mt-2 text-[13.5px] leading-relaxed text-slate-200">
                Presentazione A.C.D.T. con slide istituzionali — realizzata dal Direttivo
                per raccontare valori, missione e percorso di qualificazione professionale.
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
